export function formatGraphQlInput(input: unknown){
  return input
  ? `{ ${Object.entries(input)
      .map(([key, value]) => {
          if (value !== "") {
              return `${key} : "${value}"`
          }
          return
      })
      .join(", ")} }`
  : undefined;
}
